import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/superadmin`;

const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

export const superAdminApi = {
  overview: () => axios.get(`${API}/overview`, auth()),
  usage: () => axios.get(`${API}/usage`, auth()),
  integrations: () => axios.get(`${API}/integrations`, auth()),
  getMedidata: () => axios.get(`${API}/integrations/medidata`, auth()),
  updateMedidata: (data) => axios.put(`${API}/integrations/medidata`, data, auth()),
  listTenants: () => axios.get(`${API}/tenants`, auth()),
  createTenant: (data) => axios.post(`${API}/tenants`, data, auth()),
  updateTenant: (id, data) => axios.put(`${API}/tenants/${id}`, data, auth()),
  setTenantStatus: (id, status) => axios.post(`${API}/tenants/${id}/status`, { status }, auth()),
  deleteTenant: (id) => axios.delete(`${API}/tenants/${id}`, auth()),
  getTenantModules: (id) => axios.get(`${API}/tenants/${id}/modules`, auth()),
  setTenantModules: (id, data) => axios.put(`${API}/tenants/${id}/modules`, data, auth()),
  getTenantModulesHistory: (id, limit = 50) => axios.get(`${API}/tenants/${id}/modules/history?limit=${limit}`, auth()),
  getModulePackages: () => axios.get(`${API}/module-packages`, auth()),
  // Individuelle Konditionen & Billing-Vorschau
  getTenantConditions: (id) => axios.get(`${API}/tenants/${id}/conditions`, auth()),
  addTenantCondition: (id, data) => axios.post(`${API}/tenants/${id}/conditions`, data, auth()),
  deleteTenantCondition: (id, cid) => axios.delete(`${API}/tenants/${id}/conditions/${cid}`, auth()),
  getTenantBillingPreview: (id) => axios.get(`${API}/tenants/${id}/billing-preview`, auth()),
  // Sicherheit (2FA)
  twofaStatus: () => axios.get(`${API}/2fa/status`, auth()),
  twofaSetup: () => axios.post(`${API}/2fa/setup`, {}, auth()),
  twofaActivate: (code) => axios.post(`${API}/2fa/activate`, { code }, auth()),
  twofaDisable: (code) => axios.post(`${API}/2fa/disable`, { code }, auth()),
  // Audit-Log
  audit: (limit = 200) => axios.get(`${API}/audit?limit=${limit}`, auth()),
  // Support-Login (Impersonation)
  supportUsers: (q = '') => axios.get(`${API}/support-login/users?q=${encodeURIComponent(q)}`, auth()),
  supportLoginStart: (userId) => axios.post(`${API}/support-login/${userId}`, {}, auth()),
  // Support-Posteingang
  inboxStats: () => axios.get(`${API}/support-inbox/stats`, auth()),
  inboxCases: (params = {}) => axios.get(`${API}/support-inbox/cases`, { ...auth(), params }),
  inboxCase: (id) => axios.get(`${API}/support-inbox/cases/${id}`, auth()),
  inboxPatchCase: (id, data) => axios.patch(`${API}/support-inbox/cases/${id}`, data, auth()),
  inboxReply: (id, body) => axios.post(`${API}/support-inbox/cases/${id}/reply`, { body }, auth()),
  inboxNote: (id, body) => axios.post(`${API}/support-inbox/cases/${id}/note`, { body }, auth()),
  inboxConfig: () => axios.get(`${API}/support-inbox/config`, auth()),
  inboxSaveConfig: (data) => axios.put(`${API}/support-inbox/config`, data, auth()),
  inboxPoll: () => axios.post(`${API}/support-inbox/poll`, {}, auth()),
  inboxTeam: () => axios.get(`${API}/support-inbox/team`, auth()),
  inboxRunReminders: () => axios.post(`${API}/support-inbox/run-reminders`, {}, auth()),
  // Branchen-Freischaltung (öffentliche Auswahlseite)
  listBranches: () => axios.get(`${API}/branches`, auth()),
  setBranchEnabled: (key, enabled) => axios.put(`${API}/branches/${key}`, { enabled }, auth()),
  setBranchOrder: (keys) => axios.put(`${API}/branches/order`, { keys }, auth()),
  // Branchen-Modul-Regeln (Branchen-Automatik: Module pro Branche sperren)
  listIndustryModules: () => axios.get(`${API}/industry-modules`, auth()),
  setIndustryModules: (branche, blocked_modules) => axios.put(`${API}/industry-modules/${branche}`, { blocked_modules }, auth()),
  resetIndustryModules: (branche) => axios.delete(`${API}/industry-modules/${branche}`, auth()),
  // KI-Budget & Guthaben
  aiOverview: () => axios.get(`${API}/ai/overview`, auth()),
  aiPrices: () => axios.get(`${API}/ai/prices`, auth()),
  aiSetPrice: (data) => axios.put(`${API}/ai/prices`, data, auth()),
  aiTariffs: () => axios.get(`${API}/ai/tariffs`, auth()),
  aiSetTariff: (data) => axios.put(`${API}/ai/tariffs`, data, auth()),
  aiSetAllowance: (key, data) => axios.put(`${API}/ai/tenants/${key}/allowance`, data, auth()),
  aiRevenue: () => axios.get(`${API}/ai/revenue`, auth()),
  // Zahlungen (zwei getrennte Geldflüsse)
  payInvictax: () => axios.get(`${API}/payments/invictax`, auth()),
  paySetTenantProvider: (key, provider) => axios.put(`${API}/payments/invictax/tenants/${key}/provider`, { provider }, auth()),
  payMandanten: () => axios.get(`${API}/payments/mandanten`, auth()),
  // Software-Abo (Module)
  listModules: () => axios.get(`${API}/modules`, auth()),
  saveModule: (data) => axios.put(`${API}/modules`, data, auth()),
  translateModule: (data) => axios.post(`${API}/modules/translate`, data, auth()),
  deleteModule: (key) => axios.delete(`${API}/modules/${key}`, auth()),
  moduleSubscriptions: () => axios.get(`${API}/modules/subscriptions`, auth()),
  getSubConfig: () => axios.get(`${API}/modules/config`, auth()),
  setSubConfig: (data) => axios.put(`${API}/modules/config`, data, auth()),
  getStarterPackages: () => axios.get(`${API}/modules/starter-packages`, auth()),
  saveStarterPackage: (data) => axios.put(`${API}/modules/starter-packages`, data, auth()),
  resetStarterPackage: (branche) => axios.delete(`${API}/modules/starter-packages/${branche}`, auth()),
  listPromos: () => axios.get(`${API}/modules/promo-codes`, auth()),
  savePromo: (data) => axios.put(`${API}/modules/promo-codes`, data, auth()),
  deletePromo: (code) => axios.delete(`${API}/modules/promo-codes/${code}`, auth()),
  // Studio-Lizenz: Mengenstaffel, Mandanten-Sonderpreis, Preishistorie, Preisänderungs-Impact
  studioPriceImpact: () => axios.get(`${API}/modules/config/price-impact`, auth()),
  emailStatus: () => axios.get(`${API}/modules/email-status`, auth()),
  emailTest: (to) => axios.post(`${API}/modules/email-test`, { to }, auth()),
  getActivationEmail: () => axios.get(`${API}/modules/activation-email`, auth()),
  setActivationEmail: (data) => axios.put(`${API}/modules/activation-email`, data, auth()),
  getRecommendationConfig: () => axios.get(`${API}/modules/recommendation-config`, auth()),
  setRecommendationConfig: (recommendable_keys) => axios.put(`${API}/modules/recommendation-config`, { recommendable_keys }, auth()),
  studioPriceHistory: (limit = 100) => axios.get(`${API}/modules/studio-license/history?limit=${limit}`, auth()),
  getStudioTenantOverride: (tid) => axios.get(`${API}/modules/studio-license/tenant/${tid}`, auth()),
  setStudioTenantOverride: (tid, data) => axios.put(`${API}/modules/studio-license/tenant/${tid}`, data, auth()),
  // KI manuelle Sperre
  aiSetLock: (key, locked) => axios.put(`${API}/ai/tenants/${key}/lock`, { locked }, auth()),
  // Plattform-Zahlungskonfiguration
  getPlatformPayrexx: () => axios.get(`${API}/platform-config/payrexx`, auth()),
  savePlatformPayrexx: (data) => axios.put(`${API}/platform-config/payrexx`, data, auth()),
  getPlatformStripe: () => axios.get(`${API}/platform-config/stripe`, auth()),
  getPlatformZefix: () => axios.get(`${API}/platform-config/zefix`, auth()),
  savePlatformZefix: (data) => axios.put(`${API}/platform-config/zefix`, data, auth()),
  getPlatformAi: () => axios.get(`${API}/platform-config/ai`, auth()),
  savePlatformAi: (data) => axios.put(`${API}/platform-config/ai`, data, auth()),
  testPlatformAi: () => axios.post(`${API}/platform-config/ai/test`, {}, auth()),
  platformAiHealth: () => axios.get(`${API}/platform-config/ai/health`, auth()),
  getPlatformRefdata: () => axios.get(`${API}/platform-config/refdata`, auth()),
  savePlatformRefdata: (data) => axios.put(`${API}/platform-config/refdata`, data, auth()),
  getPlatformMedidata: () => axios.get(`${API}/platform-config/medidata`, auth()),
  savePlatformMedidata: (data) => axios.put(`${API}/platform-config/medidata`, data, auth()),
  testPlatformMedidata: () => axios.post(`${API}/platform-config/medidata/test`, {}, auth()),
  // Plattform-Abrechnung (Rechnungs-Motor)
  billingSettings: () => axios.get(`${API}/billing/settings`, auth()),
  saveBillingSettings: (data) => axios.put(`${API}/billing/settings`, data, auth()),
  billingInvoices: (params = {}) => axios.get(`${API}/billing/invoices`, { ...auth(), params }),
  billingInvoice: (id) => axios.get(`${API}/billing/invoices/${id}`, auth()),
  billingMarkPaid: (id) => axios.post(`${API}/billing/invoices/${id}/mark-paid`, {}, auth()),
  billingVoid: (id) => axios.post(`${API}/billing/invoices/${id}/void`, {}, auth()),
  billingRun: (interval = 'month') => axios.post(`${API}/billing/run`, { interval }, auth()),
  billingDunningRun: () => axios.post(`${API}/billing/dunning/run`, {}, auth()),
  billingDunning: (params = {}) => axios.get(`${API}/billing/dunning`, { ...auth(), params }),
  billingTenantPreview: (tid, interval = 'month') => axios.get(`${API}/billing/tenants/${tid}/preview`, { ...auth(), params: { interval } }),
  billingTenantGenerate: (tid, interval = 'month') => axios.post(`${API}/billing/tenants/${tid}/generate`, { interval }, auth()),
  billingTenantState: (tid) => axios.get(`${API}/billing/tenants/${tid}/state`, auth()),
  billingTenantCancel: (tid) => axios.post(`${API}/billing/tenants/${tid}/cancel`, {}, auth()),
  billingTenantRevokeCancel: (tid) => axios.post(`${API}/billing/tenants/${tid}/revoke-cancel`, {}, auth()),
  billingEmailSettings: () => axios.get(`${API}/billing/email-settings`, auth()),
  saveBillingEmailSettings: (data) => axios.put(`${API}/billing/email-settings`, data, auth()),
  billingWhatsappSettings: () => axios.get(`${API}/billing/whatsapp-settings`, auth()),
  saveBillingWhatsappSettings: (data) => axios.put(`${API}/billing/whatsapp-settings`, data, auth()),
  testBillingEmail: (data) => axios.post(`${API}/billing/email-settings/test`, data, auth()),
  testBillingWhatsapp: (data) => axios.post(`${API}/billing/whatsapp-settings/test`, data, auth()),
  billingInvoicePdf: (id) => axios.get(`${API}/billing/invoices/${id}/pdf`, { ...auth(), responseType: 'blob' }),
  billingSendInvoiceEmail: (id) => axios.post(`${API}/billing/invoices/${id}/send-email`, {}, auth()),
  // Zentrale WhatsApp-Vorlagen (Invicta-WABA)
  waTemplatesCatalog: () => axios.get(`${API}/whatsapp-templates`, auth()),
  waTemplatesSubmit: (data) => axios.post(`${API}/whatsapp-templates/submit`, data, auth()),
  waTemplatesSync: () => axios.post(`${API}/whatsapp-templates/sync`, {}, auth()),
  // WhatsApp-Gebühren weiterverrechnen (pro Meta-Konversation)
  waBillingConfig: () => axios.get(`${API}/whatsapp-billing/config`, auth()),
  waBillingSaveConfig: (data) => axios.put(`${API}/whatsapp-billing/config`, data, auth()),
  waBillingSetOverride: (tid, data) => axios.put(`${API}/whatsapp-billing/config/tenant/${tid}`, data, auth()),
  waBillingReport: (params = {}) => axios.get(`${API}/whatsapp-billing/report`, { ...auth(), params }),
  // Plattformweites Infomaniak-Backup (alle Mandanten zentral)
  backupConfig: () => axios.get(`${API}/backup/config`, auth()),
  saveBackupConfig: (data) => axios.put(`${API}/backup/config`, data, auth()),
  backupTest: (data) => axios.post(`${API}/backup/test`, data, auth()),
  backupRun: (data) => axios.post(`${API}/backup/run`, data, auth()),
  backupStatus: () => axios.get(`${API}/backup/status`, auth()),
  backupList: () => axios.get(`${API}/backup/list`, auth()),
  backupDeleteObject: (key) => axios.delete(`${API}/backup/object/${key}`, auth()),
  backupDownloadCloud: (key) => axios.get(`${API}/backup/download`, { ...auth(), params: { key }, responseType: 'blob' }),
  backupLocalList: () => axios.get(`${API}/backup/local`, auth()),
  backupLocalDownload: (filename) => axios.get(`${API}/backup/local/download/${encodeURIComponent(filename)}`, { ...auth(), responseType: 'blob' }),
  backupLocalRestore: (data) => axios.post(`${API}/backup/local/restore`, data, auth()),
  backupLocalUploadAbort: (uploadId) => axios.post(`${API}/backup/local/upload/abort`, { upload_id: uploadId }, auth()),
  // Gesamt-System-Paket (alle Mandanten + Plattform in EINER Datei)
  backupFullRun: (data) => axios.post(`${API}/backup/full/run`, data, auth()),
  backupFullStatus: () => axios.get(`${API}/backup/full/status`, auth()),
  backupFullList: () => axios.get(`${API}/backup/full/list`, auth()),
  backupFullRestore: (data) => axios.post(`${API}/backup/full/restore`, data, auth()),
  backupFullDownload: (filename) => axios.get(`${API}/backup/full/download/${encodeURIComponent(filename)}`, { ...auth(), responseType: 'blob' }),

  // Verkaufs-Generator
  salesLeads: (params = {}) => axios.get(`${API}/sales/leads`, { ...auth(), params }),
  salesCreateLead: (data) => axios.post(`${API}/sales/leads`, data, auth()),
  salesGetLead: (id) => axios.get(`${API}/sales/leads/${id}`, auth()),
  salesUpdateLead: (id, data) => axios.put(`${API}/sales/leads/${id}`, data, auth()),
  salesDeleteLead: (id) => axios.delete(`${API}/sales/leads/${id}`, auth()),
  salesReadWebsite: (id) => axios.post(`${API}/sales/leads/${id}/read-website`, {}, auth()),
  salesGenerate: (id, base_url) => axios.post(`${API}/sales/leads/${id}/generate`, { base_url }, auth()),
  salesTestSend: (id, to_email) => axios.post(`${API}/sales/leads/${id}/test-send`, { to_email }, auth()),
  salesSend: (id) => axios.post(`${API}/sales/leads/${id}/send`, {}, auth()),
  salesConvert: (id, admin_password) => axios.post(`${API}/sales/leads/${id}/convert`, { admin_password }, auth()),
  salesRefine: (id, instructions, base_url) => axios.post(`${API}/sales/leads/${id}/ai-refine`, { instructions, base_url }, auth()),
  salesCatalog: () => axios.get(`${API}/sales/feature-catalog`, auth()),
  salesGetSettings: () => axios.get(`${API}/sales/settings`, auth()),
  salesSaveSettings: (data) => axios.put(`${API}/sales/settings`, data, auth()),
};
